export default "__VITE_ASSET__CHPiS3Hv__"